import { timeStampToDateAndTime } from "../../../../../functions/dateTime/timeStampToDateAndTime";

import JobCardStatus from "./JobCardStatus";
import StageProgress from "./StageProgress";

const JobCardRow = ({ item, index, onView }) => {
  return (
    <tr className="bg-white hover:bg-gray-50 border-b [&_td]:px-4 [&_td]:py-2">
      <td>{index + 1}.</td>

      <td>
        <JobCardStatus status={item.status} />
      </td>

      <td>
        <StageProgress
          stageUpdates={item.stageUpdates}
          stageId={item.stageId}
          status={item.status}
        />
      </td>

      <td>{timeStampToDateAndTime(item.startedAt)}</td>

      <td>
        {item.completedAt
          ? timeStampToDateAndTime(item.completedAt)
          : "N/A"}
      </td>

      <td>
        <button
          className="px-4 py-[3px] bg-dBlue-100 text-dark-blue rounded-full text-xs lg:text-sm hover:bg-dark-blue hover:text-white transition"
          onClick={() => onView(item)}
        >
          View
        </button>
      </td>
    </tr>
  );
};

export default JobCardRow;